import { LIST_ACTIONS } from '../constants/appSelect';

export function checkPermission(api, actionName) {
  const checkIsAdmin = JSON.parse(localStorage.getItem('user'))?.role === 9999;
  if (checkIsAdmin) {
    return true;
  }
  const userPermissions = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user'))?.permissions : [];

  const actionId = LIST_ACTIONS.find((item) => item.label === actionName)?.value || null;

  const check = userPermissions?.findIndex((item) => item?.api === api && item.action_id === actionId);

  if (check >= 0) {
    return true;
  }
  return false;
}
